/* eslint-disable */
/**
 * 全局拦截器
 */
import qs from 'qs'
import Vue from 'vue'
import NativeApi from 'native-api'
import { isApp } from '../util/common-util'
import { appKey } from './global-config'

let userInfo
export function userInfoReady() {
    return new Promise((resovle, reject) => {
        if (userInfo) {
            resovle(userInfo)
        } else {
            NativeApi.invoke('getUserInfo', null, (info) => {
                if (info.error) {
                    reject(info.error)
                } else {
                    userInfo = info
                    resovle(userInfo)
                }
            })
        }
    })
}
const TENANT_API = 'eim-hr-plus/api/hr/plus/comm/tenant'

export function useInterceptors(netApi, flag) {
    let noErrMsgWhite = ['/eim-hr-outside/api/hr/outside/base/check-id', '/eim-hr-outside/api/hr/outside/labour','/eim-hr-outside/api/hr/outside/labour/start']
    netApi.interceptors.request.use((request) => {
        const isTenantRequest = (request.url || '').indexOf(TENANT_API) !== -1
        const tid = localStorage.getItem('tid')
        request.headers = request.headers || {}
        if (isTenantRequest) {
            delete request.headers.tid
        } else if (tid) {
            request.headers.tid = tid
        }
        if (!isApp) {
            return request
        }
        return new Promise((resolve) => {
            request.headers.clientType = 'APP'
            // request.headers.token = '2697630013iheggispupwi9635033957'
            if (request.method.toLowerCase() === 'post' && flag !== 'json') {
                if (!request.postSign) {
                    request.data = qs.stringify(request.data)
                }
            }
            userInfoReady().then((info) => {
                request.headers.token = info.token || ''
                resolve(request)
            }).catch((err) => {
                alert('无法获取用户信息')
                console.log(err)
            })
        })
    })
    netApi.interceptors.response.use(
        (response) => {
            if (!isApp) {
                let notify = Vue.prototype.$notify
                // 接口单独提示效果白名单
                if (response.data.code === 'E00007') {
                    window.location.href = response.data.redirectUrl.replace(/guazi-cloud.com/g, 'guazi-corp.com') + '?appKey=' + appKey + '&returnUrl=' + encodeURIComponent(window.location.href)
                } else if (response.data.code === 401) {
                    notify.error('没有权限')
                } else {
                    if (response.data.code !== 'S00000' && response.data.code !== 0 && response.config.responseType !== 'blob') {
                        if (!noErrMsgWhite.includes(response.config.url)) {
                            notify.error({
                                title: '请求失败',
                                message: response.data.message,
                            })
                        }
                        let error = new Error('接口请求失败')
                        error.response = response
                        return Promise.reject(error)
                    }
                }
            } else {
                // offStatus('loading')
                let code = response.data.code
                if (code !== 0 && code !== 'S00000') {
                    if (code === 2) {
                        NativeApi.invoke('login', null, (result) => {
                            if (result.code) {
                                alert(result.message) // 登陆失败
                            } else {
                                window.location.reload()
                            }
                        })
                    } else {
                        let message = response.data.message || ''
                        message && alert(message)
                    }
                    return Promise.reject(response)
                }
            }
            return response
        },
        (error) => {
            const response = error.response
            if (!isApp) {
                let notify = Vue.prototype.$notify
                if (response) {
                    if (response.status === 302) {
                        window.location.href = error.response.data.redirectUrl + '?appKey=' + appKey + '&returnUrl=' + encodeURIComponent(window.location.href)
                    }
                    if (response.status >= 500) {
                        if (response.data && response.data.message) {
                            notify.error(response.data.message)
                        } else {
                            notify.error('系统出了一点小问题/_\\')
                        }
                        return Promise.reject(error)
                    }
                    if (response.status === 401) {
                        notify.error('没有权限')
                        return Promise.reject(error)
                    }
                    let errors = ''
                    for (const message in response.data.messages) {
                        if (response.data.messages.hasOwnProperty(message)) {
                            errors += message + ':' + response.data.messages[message].join('|') + '\n'
                        }
                    }
                    errors = (errors || response.data.message)
                    errors && !noErrMsgWhite.includes(response.config.url) && notify.error(errors)
                    return Promise.reject(error)
                }
                notify.error('接口错误, 请重试或联系开发人员')
                return Promise.reject(error)
            }
            // offStatus('loading')
            if (response) {
                if (response.status >= 500) {
                    if (response.data && response.data.message) {
                        alert(response.data.message)
                    } else {
                        alert('系统出了一点小问题/_\\')
                    }
                    return Promise.reject(error)
                }
                if (response.status === 401) {
                    alert('当前用户未登录')
                    return Promise.reject(error)
                }
                let errors = ''
                for (let message in response.data.messages) {
                    if (response.data.messages.hasOwnProperty(message)) {
                        errors += message + ':' + response.data.messages[message].join('|') + '\n'
                    }
                }
                errors = (errors || response.data.message)
                errors && alert(errors)
                return Promise.reject(error)
            }

            return Promise.reject(error)
        },
    )
}
